'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (text, options) {
  var entities = (0, _extractMentionsOrListsWithIndices2.default)(text);
  return (0, _autoLinkEntities2.default)(text, entities, options);
};

var _extractMentionsOrListsWithIndices = require('./extractMentionsOrListsWithIndices');

var _extractMentionsOrListsWithIndices2 = _interopRequireDefault(_extractMentionsOrListsWithIndices);

var _autoLinkEntities = require('./autoLinkEntities');

var _autoLinkEntities2 = _interopRequireDefault(_autoLinkEntities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default']; // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0